import React, { useCallback } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useLoading, useUserInfo } from '../../../hooks';
import { recommendAiBarosamDetAPI, recommendDetAPI } from '../../../api/ocrAPI';
import { TYPE, URL } from '../../../constant';

function OcrHistoryItem({ dayItem, handleChecked, setDeletePopup }) {
  return (
    <article>
      <div className="tit">
        <p>{moment(dayItem[0]).format('YYYY. MM. DD')}</p>
      </div>
      {
        dayItem[1].map((item, index) => (
          <ImageItem
            key={index}
            item={item}
            setDeletePopup={setDeletePopup}
            handleChecked={handleChecked}
          />
        ))
      }
    </article>
  );
}

function ImageItem({ item, handleChecked, setDeletePopup }) {
  const history = useHistory();
  const { info } = useUserInfo();
  const { setLoading, clearLoading } = useLoading();

  const handleChange = useCallback((e, item) => {
    const isChecked = e.target.checked;
    if (!isChecked) {
      document.getElementById('input-chk_all').checked = false;
    }

    handleChecked(e, 'one', item);
  }, [item]);

  const handleClick = useCallback(async (item) => {
    setLoading({ isShowSpinner: true, spinnerType: '1' });
    try {
      let data = null;
      if (info.channelCode === TYPE.CHANNEL.GM) {
        data = await recommendAiBarosamDetAPI({
          learner_id: info.learnerId,
          // learner_id: 'LRN20210812140000542',
          url: `${item.ocrImgFilePath}/${item.ocrImgFileNm}`
        });
      } else {
        data = await recommendDetAPI({
          learner_id: info.learnerId,
          // learner_id: 'LRN20210812140000542',
          url: `${item.ocrImgFilePath}/${item.ocrImgFileNm}`
        });
      }

      if (data?.code === 'E000000') {
        setDeletePopup(true);
        return;
      }
      const { recresult, showtext_encoded } = data.resp;

      if (!recresult) return;

      history.push({
        pathname: `${URL.OCR.RECOMMEND_LEARNING}`,
        state: {
          isBack: 'Y',
          data: recresult.result,
          average: recresult.percent,
          latex: showtext_encoded,
          fulls3path: `${item.ocrImgFilePath}/${item.ocrImgFileNm}`
        }
      });

    } catch (error) {
      console.log("##### recommendDetAPI error: ", error);
    } finally {
      clearLoading();
    }
  }, [])

  return (
    <div className="line">
      <div className="custom-radio-wrap gray">
        <input
          type="checkbox"
          name="input-chk01-item"
          id={`input-chk01_${item.hstSno}`}
          onChange={(e) => handleChange(e, item)}
        />
        <label htmlFor={`input-chk01_${item.hstSno}`}>
          <span
            onClick={() => handleClick(item)}
            style={{ backgroundImage: `url(${item.ocrImgFilePath}/${item.ocrImgFileNm})` }}
          />
        </label>
      </div>
    </div>
  )
}

export default OcrHistoryItem;